// Copyright (c) 2016 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValueDefaultState} from './key-value-pair';
import t from 'tcomb';

const ClaimBatteryAdditionalFailureInfo = t.struct({
    dtacCase: t.String,
    dtacSolution: t.String,
    dtacUrl: t.maybe(t.String),
    failureArea: t.String,
    failureMode: KeyValuePair,
    failureModeComments: t.String,
    failurePartSerialNumber: t.maybe(t.String)
}, {
    name: 'ClaimBatteryAdditionalFailureInfo',
    strict: true
});

export const getDefaultState = () => new ClaimBatteryAdditionalFailureInfo({
    dtacCase: '',
    dtacSolution: '',
    dtacUrl: '',
    failureArea: '',
    failureMode: getKeyValueDefaultState(),
    failureModeComments: '',
    failurePartSerialNumber: ''
});

export default ClaimBatteryAdditionalFailureInfo;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-battery-additional-failure-info.js